import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { IFilterServiceDto } from 'src/app/models/Ifilter-service-dto';
import { IService } from 'src/app/models/iservice';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.scss']
})
export class RequestDetailsComponent implements OnInit {
  isLoading:boolean;
  uploadedFiles: any[] = [];
  services:IService[];
  selectedService:any;
  siteSittingDateFormat:string = 'dd/MM/yyyy';
  constructor(private helperService:HttphelperService,private translate: TranslateService,
    private cd:ChangeDetectorRef,private router:Router,public breadSer:BreadcrumbService,private messageService: MessageService) { }

  ngOnInit(): void {
    this.uploadedFiles = this.breadSer.uploadedFiles;
    if(this.breadSer.clinicTypeId == null || this.breadSer.clinicTypeId == undefined){
      this.router.navigate(['newrequest/category']);
      return;
    }
    if(this.breadSer.numberOfSpecialty > 1 ){
      this.breadSer.menuItems.length = 3;
    }else{
      this.breadSer.menuItems.length = 2;
    }
    this.breadSer.menuItems.push({label: "Request Details", routerLink: ['requestdetails']});
    this.loadServicesData();
  }
  selectAnotherTime(timeSelected :string){
    this.breadSer.callQueue.AppointmentTime = timeSelected;
    this.cd.detectChanges();
  }
  proceedToPayment(){
    this.breadSer.uploadedFiles = this.uploadedFiles;
    this.breadSer.menuItems.push({label: "Confirm Payment", routerLink: ['confirmpayment']});
    this.router.navigate(['newrequest/confirmpayment']);
  }
  changeService(dd:any){
    this.breadSer.callQueue.ServiceId = dd.selectedOption.id;
    this.breadSer.price = dd.selectedOption.price;
    this.cd.detectChanges();
  }
  onAttachmentSelected(event) {
    this.uploadedFiles = event.currentFiles;
  }
  loadServicesData(){
    let filter :IFilterServiceDto  =  
    {
      ClinicId : this.breadSer.callQueue.ClinicID,
      ClinicTypeId : this.breadSer.clinicTypeId,
      IsTelemedVisit : this.breadSer.addtionalData.istele,
      IsHomeVisit : this.breadSer.addtionalData.ishome,
      IsClinicVisit : this.breadSer.addtionalData.isclinic,
      RequestType : 0
    };
    this.services = [];
    var url = `/api/Queue/GetServices`;
    this.helperService.postRequest(url,true,filter).subscribe(response =>
    {
      if(response.Success)
      {
        this.services = response?.Data;
        if(this.services == null || this.services == undefined)
        {
          this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
        }
        else
        {
          this.selectedService = this.breadSer.callQueue.ServiceId;
        }
      }
      else
      {
        this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
    })
  }
}
